import { render, staticRenderFns } from "./CmgPointsHistory.vue?vue&type=template&id=0539c23c&scoped=true&lang=pug"
import script from "./cmg-points-history.ts?vue&type=script&lang=ts&external"
export * from "./cmg-points-history.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPointsHistory.vue?vue&type=style&index=0&id=0539c23c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539c23c",
  null
  
)

export default component.exports